import { graphql } from "@/types/gql";

export const QUERY_CURB_ZONES = graphql(`
  query CurbZones($filterInput: SearchCurbZoneInput!) {
    curbZones(filterInput: $filterInput) {
      calculatedArea
      calculatedSpaces
      cityId
      curbPolicies {
        id
        curbPolicyId
        name
        rules {
          maxStay
          maxStayUnit
          rate {
            rate
            rateUnit
          }
        }
        timeSpans {
          daysOfWeek
          timeOfDayStart
          timeOfDayEnd
        }
        color {
          dashed
          fillColor
          lineColor
        }
        cityId
        publishedDate
        priority
      }
      curbPolicyIds
      editLine
      externalId
      geoPoint2d
      geometry
      id
      curbZoneId
      length
      name
      note
      parkingAngle
      publishedDate
      startDate
      streetName
      streetNumberStart
      streetNumberEnd
      width
      decreeIds
      decrees {
        name
        id
      }
    }
  }
`);

export const QUERY_CREATE_CURB_ZONE = graphql(`
  mutation CreateCurbZone($curbZoneInput: CreateCurbZoneInput!) {
    createCurbZone(curbZoneInput: $curbZoneInput) {
      calculatedArea
      calculatedSpaces
      cityId
      curbPolicies {
        id
        curbPolicyId
        name
        rules {
          maxStay
          maxStayUnit
          rate {
            rate
            rateUnit
          }
          activity
        }
        timeSpans {
          daysOfWeek
          timeOfDayStart
          timeOfDayEnd
        }
        color {
          dashed
          fillColor
          lineColor
        }
        priority
        cityId
        publishedDate
      }
      curbPolicyIds
      editLine
      externalId
      geoPoint2d
      geometry
      id
      curbZoneId
      length
      name
      note
      parkingAngle
      publishedDate
      startDate
      streetName
      streetNumberEnd
      streetNumberStart
      width
      decreeIds
      decrees {
        name
        id
      }
    }
  }
`);

export const QUERY_UPDATE_CURB_ZONE = graphql(`
  mutation UpdateCurbZone($curbZoneInput: UpdateCurbZoneInput!) {
    updateCurbZone(curbZoneInput: $curbZoneInput) {
      calculatedArea
      calculatedSpaces
      cityId
      curbPolicies {
        id
        curbPolicyId
        name
        rules {
          maxStay
          maxStayUnit
          rate {
            rate
            rateUnit
          }
          activity
        }
        timeSpans {
          daysOfWeek
          timeOfDayStart
          timeOfDayEnd
        }
        color {
          dashed
          fillColor
          lineColor
        }
        priority
        cityId
        publishedDate
      }
      curbPolicyIds
      editLine
      externalId
      geoPoint2d
      geometry
      id
      curbZoneId
      length
      name
      note
      parkingAngle
      publishedDate
      startDate
      streetName
      streetNumberEnd
      streetNumberStart
      width
      decreeIds
      decrees {
        name
        id
      }
    }
  }
`);

export const QUERY_BULK_UPDATE_CURB_ZONE = graphql(`
  mutation BulkUpdateCurbZone($bulkUpdateCurbZoneInputs: [UpdateCurbZoneInput!]!) {
    bulkUpdateCurbZones(curbZoneInputs: $bulkUpdateCurbZoneInputs) {
      calculatedArea
      calculatedSpaces
      cityId
      curbPolicies {
        id
        curbPolicyId
        name
        rules {
          maxStay
          maxStayUnit
          rate {
            rate
            rateUnit
          }
          activity
        }
        timeSpans {
          daysOfWeek
          timeOfDayStart
          timeOfDayEnd
        }
        color {
          dashed
          fillColor
          lineColor
        }
        priority
        cityId
        publishedDate
      }
      curbPolicyIds
      editLine
      externalId
      geoPoint2d
      geometry
      id
      curbZoneId
      length
      name
      note
      parkingAngle
      publishedDate
      startDate
      streetName
      streetNumberEnd
      streetNumberStart
      width
      decreeIds
      decrees {
        name
        id
      }
    }
  }
`);

export const QUERY_REMOVE_CURB_ZONE = graphql(`
  mutation DeleteCurbZone($curbZoneId: String!) {
    deleteCurbZone(curbZoneId: $curbZoneId) {
      id
    }
  }
`);

export const QUERY_REMOVE_CURB_ZONES = graphql(`
  mutation BulkDeleteCurbZones($curbZoneIds: [String!]!) {
    bulkDeleteCurbZones(curbZoneIds: $curbZoneIds) {
      id
    }
  }
`);

export const QUERY_GET_TOTAL_CALCULATED_SPACES = graphql(`
  query TotalCalculatedSpaces($filterInput: SearchCalculatedSpacesInput!) {
    getTotalCalculatedSpaces(filterInput: $filterInput)
  }
`);

export const CURB_ZONES_STATS_QUERY = graphql(`
  query CurbZoneStats($filterInput: SearchCurbZoneInput!) {
    curbZones(filterInput: $filterInput) {
      streetName
      calculatedArea
      calculatedSpaces
      curbPolicies {
        curbPolicyId
        name
        color {
          lineColor
        }
      }
    }
  }
`);

export const QUERY_CURB_ZONES_BY_PARKING_LOT = graphql(`
  query CurbZonesByParkingLot($filterInput: SearchCurbZoneInput!) {
    curbZones(filterInput: $filterInput) {
      id
      curbZoneId
    }
  }
`);

export const QUERY_CURB_ZONES_SHORTEN = graphql(`
  query CurbZonesShorten($filterInput: SearchCurbZoneInput!) {
    curbZones(filterInput: $filterInput) {
      curbPolicies {
        id
        name
        color {
          dashed
          fillColor
          lineColor
        }
      }
      editLine
      geoPoint2d
      geometry
      id
      curbZoneId
      width
    }
  }
`);
